import { BaseDataService } from './BaseDataService';
import { ScoreCardGroup } from '../../models';
import { NotificationService } from '../../services';

export class ScoreCardGroupDataService extends BaseDataService<ScoreCardGroup> {
    constructor(notificationService: NotificationService) {
        super('Score Card Group', 'Score Card Groups', notificationService);
    }
}


// WEBPACK FOOTER //
// ./src/services/api/ScoreCardGroupDataService.tsx